import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { componentInvariants } from 'bloko/common/helpers/customPropTypes';

import 'bloko/blocks/link/link.less';

export default class Link extends PureComponent {
    static propTypes = {
        /** Содержимое внутри */
        children: PropTypes.node,
        /** Тип ссылки*/
        kind: PropTypes.oneOf(['dimmed', 'notify', 'list', 'secondary', 'on-dark']),
        /** Кастомный компонент*/
        Element: componentInvariants(['a', 'span', 'button']),
    };

    static defaultProps = {
        Element: 'a',
    };

    render() {
        const { kind, Element, children, ...linkProps } = this.props;

        const className = classnames('bloko-link', {
            [`bloko-link_${kind}`]: kind,
        });

        return (
            <Element className={className} {...linkProps}>
                {children}
            </Element>
        );
    }
}
